var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7501 6.88672H17.1155",
    stroke: "#C5482C",
    strokeWidth: 1.19044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34039 6.88672H8.75018",
    stroke: "#C5482C",
    strokeWidth: 1.19044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1538 6.88672L18.4563 23.9157",
    stroke: "#C5482C",
    strokeWidth: 1.19044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3601 6.88672L20.0522 19.5648",
    stroke: "#C5482C",
    strokeWidth: 1.19044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93864 6.88672L10.2121 23.8375",
    stroke: "#C5482C",
    strokeWidth: 1.19044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15276 6.88672L11.816 19.4866",
    stroke: "#C5482C",
    strokeWidth: 1.19044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.325 12.7637L10.2261 23.8386",
    stroke: "#C5482C",
    strokeWidth: 1.19044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7152 12.3887L18.4491 23.9155",
    stroke: "#C5482C",
    strokeWidth: 1.19044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6932 12.3896C22.9361 11.544 23.901 10.2786 23.901 8.45859C23.901 5.60569 22.977 4.45801 21.4707 4.45801C20.2397 4.45801 19.802 5.64036 19.802 6.62832C19.802 9.55994 22.6932 9.96515 22.6932 12.3896Z",
    stroke: "#C5482C",
    strokeWidth: 1.19044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWp);
export default __webpack_public_path__ + "static/media/WP.b43a4dd30c6e137071529009e1e64b25.svg";
export { ForwardRef as ReactComponent };